import React from "react";
import 'react-chatbot-kit/build/main.css';
import './styles/widget.css';
import Stepper from "./components/steps/Stepper";
import { BrowserRouter, Routes, Route } from "react-router";


function App() {
  return (
    <div className="widget flex w-full h-[100vh] justify-center items-center">
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Stepper />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
